function initializeCombatPage() {

(function initCombatSequence(){
  var wrap=document.getElementById('combatSeq'); if(!wrap) return;
  if(wrap.dataset.sequenceReady) return; wrap.dataset.sequenceReady='true';
  var frames=[].slice.call(wrap.querySelectorAll('img')); if(!frames.length) return;
  var reduce=window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var active=false, raf=0, last=-1;
  function setFrame(i){
    i=Math.max(0,Math.min(frames.length-1,i)); if(i===last) return;
    for(var n=0;n<frames.length;n++){ frames[n].classList.toggle('is-active',n===i); }
    last=i;
  }
  if(reduce){ setFrame(Math.floor((frames.length-1)/2)); return; }
  function update(){
    raf=0;
    var r=wrap.getBoundingClientRect(), vh=window.innerHeight||1;
    var p=(vh-r.top)/(vh+r.height); p=Math.max(0,Math.min(0.999,p));
    setFrame(Math.floor(p*frames.length));
  }
  function onScroll(){ if(active && !raf) raf=window.requestAnimationFrame(update); }
  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(es){ for(var k=0;k<es.length;k++){ active=es[k].isIntersecting; if(active) onScroll(); } },{rootMargin:'180px'});
    io.observe(wrap);
  } else { active=true; }
  window.addEventListener('scroll',onScroll,{passive:true});
  window.addEventListener('resize',onScroll);
  wrap.addEventListener('ka:dispose', function(){ window.removeEventListener('scroll',onScroll); window.removeEventListener('resize',onScroll); if(io) io.disconnect(); if(raf) window.cancelAnimationFrame(raf); });
  update();
})();

}
initializeCombatPage();
document.addEventListener('shopify:section:load', initializeCombatPage);
document.addEventListener('shopify:section:unload', function(event) { event.target.querySelectorAll('[data-sequence-ready]').forEach(function(element) { element.dispatchEvent(new Event('ka:dispose')); }); });
